// CustomTableDataStyles.ts
import { useCurrentTheme } from "../../../../theme/theme";

export type ThemeCustomTableStyle = ReturnType<typeof useCurrentTheme>["theme"];

export const useCustomTableDataStyles = () => {
	const { theme } = useCurrentTheme();

	const textPaletteColor = theme.palette.primary.contrastText;

	return {
		"& .MuiDataGrid-columnSeparator": {
			color: textPaletteColor,
		},
		"& .MuiDataGrid-columnSeparator:hover": {
			color: textPaletteColor,
		},
		"& .MuiDataGrid-columnHeaders": {
			backgroundColor: theme.palette.primary.main,
		},
		"& .MuiDataGrid-row:nth-of-type(even)": {
			backgroundColor: theme.palette.background.elevation0,
		},
		"& .MuiDataGrid-scrollbarFiller": {
			backgroundColor: `${theme.palette.primary.main} !important`,
		},
		"& .MuiDataGrid-scrollbarFiller--header": {
			backgroundColor: `${theme.palette.primary.main} !important`,
		},

		"& .MuiDataGrid-columnHeader:hover": {
			"& .MuiDataGrid-sortIcon": {
				color: textPaletteColor,
				opacity: 1,
				transition: "none",
			},
			"& .MuiDataGrid-menuIconButton": {
				color: textPaletteColor,
				opacity: 1,
				transition: "none",
			},
		},

		"& .MuiDataGrid-sortIcon, & .MuiDataGrid-menuIconButton": {
			opacity: 0.6,
			transition: "none",
		},

		"& .MuiDataGrid-columnHeader--sorted .MuiDataGrid-sortIcon": {
			color: textPaletteColor,
			opacity: 1,
			transition: "none",
		},
	} satisfies Record<string, any>;
};
